import debounce from 'debounce'

document.addEventListener('DOMContentLoaded', () => {
	const map = document.querySelector('#map');

	if (map) {
		const mapEl = document.getElementById('map')
		if (mapEl) {
			window.addEventListener('load', initMap)
		}

		function initMap() {
			const marker = _mapMarker
			marker['markerObj'] = {
				lat: parseFloat(marker.latitude),
				lng: parseFloat(marker.longitude),
			}
			const centerPosition = marker.markerObj

			var bounds = new google.maps.LatLngBounds()
			bounds.extend(new google.maps.LatLng(marker.markerObj.lat, marker.markerObj.lng))

			let zoomLevel
			if (window.innerWidth >= 1200) {
				zoomLevel = 15
			} else if (window.innerWidth >= 992) {
				zoomLevel = 14
			} else {
				zoomLevel = 13
			}

			const map = new google.maps.Map(document.getElementById('map'), {
				center: centerPosition,
				zoom: zoomLevel,
				mapId: 'dd4ef537f8eb962613f96d1b',
				streetViewControl: false,
				mapTypeControl: false,
				fullscreenControl: false,
			})

			const contentString =
				`<div class="tooltip-content">
						<p class="location-name"><strong>${marker.location_name}</strong></p>
						<p class="sm"><a href="${marker.address_link}" target="_blank">${marker.address_string}</a></p>
					</div>`

			const infowindow = new google.maps.InfoWindow({
				content: contentString,
			})

			const image = {
				url: '/wp-content/themes/propaganda-theme/assets/icons/map-marker.svg',
				size: new google.maps.Size(26, 37),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(13, 37),
			}

			let mrkr = new google.maps.Marker({
				position: marker.markerObj,
				map,
				icon: image,
			})

			mrkr.addListener('click', () => {
				infowindow.open({
					anchor: mrkr,
					map,
					shouldFocus: false,
				})
			})

			const refreshCenter = debounce(() => {
				map.setCenter(centerPosition)

				var center = map.getCenter()
				var centerPoint = map.getProjection().fromLatLngToPoint(center)
				map.setCenter(map.getProjection().fromPointToLatLng(centerPoint))
			}, 100)

			map.addListener('projection_changed', () => {
				refreshCenter()
			})

			window.addEventListener('resize', () => {
				refreshCenter()
			})

			google.maps.event.addListenerOnce(map, 'idle', () => {
				refreshCenter()
			})
		}
	}
})
